import React, { useState } from "react";

const FormFilters = ({ setSearchWord, setChanged, icoSearch, logo, label }) => {
	const [inputVal, setInputVal] = useState("");

	const handleInputChange = (e) => {
		setSearchWord(e.target.value);
		setInputVal(e.target.value.toLowerCase());
		setChanged("field");
	};

	const handleFormSubmit = (e) => {
		e.preventDefault();
		setSearchWord(inputVal.toLowerCase());
		setChanged("field");
	};

	return (
		<div className="form-filters">
			<form
				action="?"
				method="post"
				onSubmit={(e) => handleFormSubmit(e)}
			>
				<div className="form__logo">
					<img src={logo} alt="" />
				</div>

				<div className="form__row">
					<div className="form__controls form__controls--field">
						<label htmlFor="field-1#">{label}</label>

						<input
							type="text"
							className="field"
							name="field-1#"
							id="field-1#"
							defaultValue=""
							placeholder="Search"
							onChange={(e) => handleInputChange(e)}
						/>
					</div>
				</div>

				<div className="form__actions">
					<button type="submit">
						<img src={icoSearch} alt="" />
					</button>
				</div>
			</form>
		</div>
	);
};

export default FormFilters;
